import React, { FC, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useRecoverPasswordMutation } from "store/api";
import NcModal from 'shared/NcModal/NcModal';
import { useNavigate } from "react-router-dom";

export interface PageRecoverPasswordProps {
  className?: string;
}


const PageRecoverPassword: FC<PageRecoverPasswordProps> = ({ className = "" }) => {
  const email = useRef<HTMLInputElement>(null);
  const [alert, setAlert] = useState<string | null>(null);
  const [recoverPassword] = useRecoverPasswordMutation();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async(event:React.FormEvent) => {
    event.preventDefault();
    if (email.current?.value==='') {
      setAlert('Por favor, ingresa tu correo');
      setTimeout(() => setAlert(null), 2000);
      return;
    }else{
      setIsLoading(true);
      const {error, data} = await recoverPassword({email:email.current?.value.trim().toLowerCase()});

      if(error){
        if ('status' in error) {
          const fetchError = error as { status: number; data: { message: string; statusMessage: string } };
          if(fetchError.status===404)setAlert('Usuario no encontrado');
          else setAlert('Algo salió mal. Intenta nuevamente.');
          setTimeout(() => setAlert(null), 2000);
        }
      }

      if(data)if(data.meta.status===200)setIsOpen(true);
      
      setIsLoading(false);
    }
  };

  const handleCloseModal = () => {
    setIsOpen(false);
    setIsLoading(false);
    navigate('/login');
  }

  return (
    <div className={`nc-PageLogin ${className}`} data-nc-id="PageLogin">
      <Helmet>
        <title>Bee || Recuperar Contraseña</title>
      </Helmet>
      <div className="container mb-24 lg:mb-32">
        <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
          Recuperar Contraseña
        </h2>
        <div className="max-w-md mx-auto space-y-6">
          <form className="grid grid-cols-1 gap-6" onSubmit={handleSubmit}>
            <label className="block">
              <span className="text-neutral-800 dark:text-neutral-200">
                Correo
              </span>
              <Input
                type="email"
                ref={email}
                className="mt-1"
              />
            </label>
            <NcModal
              renderTrigger={(openModal) => (
                <div className="items-center transition duration-150 ease-in-out rounded-lg">
                  <ButtonPrimary loading={isLoading} type="submit" className="w-full">Continuar</ButtonPrimary>
                </div>
              )}
              isOpenProp={isOpen}
              onCloseModal={handleCloseModal}
              contentExtraClass="w-full sm:w-1/2"
              renderContent={()=><p className="text-base">Se ha enviado un correo con un enlace para restablecer tu contraseña. Por favor, revisa tu bandeja de entrada o spam y sigue las instrucciones.</p>}
              modalTitle="Cambiar contraseña"
            />
          </form>
        </div>
      </div>
      {alert && (
        <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-6 py-3 rounded-2xl shadow-2xl transition-all duration-300 ease-in-out opacity-90 hover:opacity-100 hover:scale-105 flex items-center gap-4">
          {alert}
        </div>
      )}
    </div>
  );
};

export default PageRecoverPassword;
